import { render, staticRenderFns } from "./NewsSection.vue?vue&type=template&id=2dfcba46&scoped=true&"
import script from "./NewsSection.vue?vue&type=script&lang=js&"
export * from "./NewsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfcba46",
  null
  
)

export default component.exports